import { QuoteStatus } from "@assets/constants";
import { ListQuoteVM } from "@assets/types";
import {
  FilterQuoteState,
  initialFilterQuotesState,
} from "@state/slices/filterQuoteSlice";

const isSearchFiltered = (filterSearch: string, quoteReference: string) =>
  filterSearch === initialFilterQuotesState.search ||
  quoteReference.match(new RegExp(filterSearch, "i"));

const isStatusFiltered = (
  filterStatus: QuoteStatus,
  quoteStatus: QuoteStatus
) =>
  filterStatus === initialFilterQuotesState.status ||
  quoteStatus === filterStatus;

const isFromLocationFiltered = (
  filterFromLocation: string,
  quoteFromLocation: string
) =>
  filterFromLocation === initialFilterQuotesState.fromLocation ||
  quoteFromLocation === filterFromLocation;

const isToLocationFiltered = (
  filterToLocation: string,
  quoteToLocation: string
) =>
  filterToLocation === initialFilterQuotesState.toLocation ||
  quoteToLocation === filterToLocation;

const isShipmentTypeFiltered = (
  filterShipmentTypes: string[],
  quoteShipmentType: string
) =>
  filterShipmentTypes.length === 0 ||
  filterShipmentTypes.includes(quoteShipmentType);

/**
 * Determines if the given quote matches the filter conditions
 * @param quote The quote to be filtered or not
 * @param filterState The filter states
 * @returns True if the quote matches all filters, false if it doesn't match at least one
 */
export const isAllActiveFilters = (
  quote: ListQuoteVM,
  filterState: FilterQuoteState
) => {
  return (
    isStatusFiltered(filterState.status, quote.Status) &&
    isSearchFiltered(filterState.search, quote.QuoteReference) &&
    isFromLocationFiltered(filterState.fromLocation, quote.FromAddress.City) &&
    isToLocationFiltered(filterState.toLocation, quote.ToAddress.City) &&
    isShipmentTypeFiltered(filterState.shipmentTypes, quote.ShipmentType)
  );
};
